import {NOT_SELECTED} from '../enum';

function isSelected(index) {
    return index > NOT_SELECTED;
}

function getResultByIndex(results, destinationIndex, subDestinationIndex) {
    // set first item as default
    let destination = results[0];
    let subDestination = null;
    if (isSelected(destinationIndex)) {
        destination = results[destinationIndex];
        if (isSelected(subDestinationIndex)) {
            subDestination = destination.subSuggestions[subDestinationIndex];
        }
    }
    return {
        destination,
        subDestination
    };
}

export function getCurrentDestinationIndex(index) {
    return index === NOT_SELECTED ? 0 : index;
}

export function getSelectedResult(
    results,
    destinationIndex,
    subDestinationIndex
) {
    if (results && results.length && results.length > 0) {
        return getResultByIndex(results, destinationIndex, subDestinationIndex);
    }
    return {};
}

/* eslint-disable complexity */
function previousIndex(results, destinationIndex, displayFilters) {
    if (destinationIndex > 0) {
        const prevDestinationIndex = destinationIndex - 1;
        const prevResult = results[prevDestinationIndex];
        const prevSubDestinations = prevResult.subSuggestions;
        if (
            prevSubDestinations &&
            !prevResult.recentlyviewed &&
            displayFilters
        ) {
            return {
                selectDestinationIndex: prevDestinationIndex,
                selectDestinationSubIndex: prevSubDestinations.length - 1
            };
        }
        return {
            selectDestinationIndex: prevDestinationIndex,
            selectDestinationSubIndex: NOT_SELECTED
        };
    }

    const lastDestinationIndex = results.length - 1;
    const lastSubDestinations = results[lastDestinationIndex].subSuggestions;
    if (lastSubDestinations) {
        return {
            selectDestinationIndex: lastDestinationIndex,
            selectDestinationSubIndex: lastSubDestinations.length - 1
        };
    }
    return {
        selectDestinationIndex: lastDestinationIndex,
        selectDestinationSubIndex: NOT_SELECTED
    };
}
/* eslint-enable complexity */

function nextIndex(results, destinationIndex) {
    if (destinationIndex < results.length - 1) {
        return {
            selectDestinationIndex: destinationIndex + 1,
            selectDestinationSubIndex: NOT_SELECTED
        };
    }
    return {
        selectDestinationIndex: 0,
        selectDestinationSubIndex: NOT_SELECTED
    };
}

export function getPreviousResultIndex(
    results,
    destinationIndex,
    subDestinationIndex,
    displayFilters
) {
    if (subDestinationIndex >= 0 && displayFilters) {
        return {
            selectDestinationSubIndex: subDestinationIndex - 1
        };
    }
    return previousIndex(results, destinationIndex, displayFilters);
}

/* eslint-disable complexity */
export function getNextResultIndex(
    results,
    destinationIndex,
    subDestinationIndex,
    displayFilters
) {
    if (destinationIndex === NOT_SELECTED) {
        return {
            selectDestinationIndex: 0
        };
    }
    const currentResult = results[destinationIndex];
    const currentSubDestinations = currentResult.subSuggestions;
    if (
        !currentResult.recentlyviewed &&
        displayFilters &&
        currentSubDestinations &&
        currentSubDestinations.length - 1 > subDestinationIndex
    ) {
        return {
            selectDestinationSubIndex: subDestinationIndex + 1
        };
    }
    return nextIndex(results, destinationIndex);
}
/* eslint-enable complexity */
